import axios from 'axios';

const baseApiURL = process.env.REACT_APP_API_METRICS_BASE_URL;

const apiMetrics = axios.create({
  baseURL: baseApiURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiMetrics.interceptors.request.use(
  async (config) => {
    const userToken = localStorage.getItem('@Cinco:token');
    if (config.headers) {
      config.headers.Authorization = `Bearer ${userToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export { apiMetrics };
